import { Directive, ElementRef, AfterViewInit, OnDestroy, inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Directive({
  selector: '[app-follow-top-help]',
  standalone: true
})
export class FollowTopHelpDirective implements AfterViewInit, OnDestroy {
  public readonly host = inject(ElementRef<HTMLElement>);
  private readonly platformId = inject(PLATFORM_ID);

  private resizeObserver!: ResizeObserver;

  ngAfterViewInit(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    const update = () => {
      const rect = this.host.nativeElement.getBoundingClientRect();
      const rootStyle = document.documentElement.style;
      rootStyle.setProperty('--pane-help-top', `calc(${Math.round(rect.height)}px - 8rem)`);
    };
    update();
    this.resizeObserver = new ResizeObserver(update);
    this.resizeObserver.observe(this.host.nativeElement);
  }

  ngOnDestroy(): void {
    this.resizeObserver?.disconnect();
  }
}
